import {
  UpgradeConfigurationDto,
  UpgradeConfigurationSchema,
  DiscountApplied,
  GeneralActivationRule,
  NotificationChannelEnum,
  SellingConfigurationTypeEnum,
  SellingLocationEnum,
  UpgradeTarget,
} from "./upgradeConfiguration.schema";

export class UpgradeConfigurationEntity {
  private constructor(
    readonly id: string,
    readonly active: boolean,
    readonly propertyTicker: string,
    readonly propertyRecipients: string[],
    readonly sellingLocations: SellingLocationEnum[],
    readonly notificationChannels: NotificationChannelEnum[],
    readonly sellingConfigurationType: SellingConfigurationTypeEnum,
    readonly sellingTargets: UpgradeTarget[],
    readonly generalSellingActivationRule: GeneralActivationRule,
    readonly discountApplied: DiscountApplied | undefined,
    readonly createdAt: Date,
    readonly updatedAt: Date
  ) {}

  static of(props: UpgradeConfigurationDto): UpgradeConfigurationEntity {
    const validated = UpgradeConfigurationSchema.parse(props);
    return new UpgradeConfigurationEntity(
      validated.id,
      validated.active,
      validated.propertyTicker,
      validated.propertyRecipients,
      validated.sellingLocations,
      validated.notificationChannels,
      validated.sellingConfigurationType,
      validated.sellingTargets,
      validated.generalSellingActivationRule,
      validated.discountApplied,
      validated.createdAt,
      validated.updatedAt
    );
  }

  toDto(): UpgradeConfigurationDto {
    return {
      id: this.id,
      active: this.active,
      propertyTicker: this.propertyTicker,
      propertyRecipients: this.propertyRecipients,
      sellingLocations: this.sellingLocations,
      notificationChannels: this.notificationChannels,
      sellingConfigurationType: this.sellingConfigurationType,
      sellingTargets: this.sellingTargets,
      generalSellingActivationRule: this.generalSellingActivationRule,
      discountApplied: this.discountApplied,
      createdAt: this.createdAt,
      updatedAt: this.updatedAt,
    };
  }
}
